import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    typifications: `${APP_CONFIG.care_cluster}/ms-typifications`,
  },
}
